import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notification } from "antd";
import "./login.css";
import { API_URL } from "../../../environment";
import ApiClient from "../../../api/apiClient";
import { FiEye } from "react-icons/fi";
import { FaRegEyeSlash } from "react-icons/fa6";

const Login = () => {
  const [position, setPosition] = useState({ lat: null, lon: null });

  const navigate = useNavigate();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [widths, setWidths] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [ipAddress, setIpAddress] = useState("");
  const [locationData, setLocationData] = useState(null);
  const [deviceDetails, setDeviceDetails] = useState({
    deviceType: "",
    os: "",
  });

  useEffect(() => {
    Screenwidth();
    check();
    // Check if geolocation is available
    if ("geolocation" in navigator) {
      // Get the current position
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setPosition({ lat: latitude, lon: longitude });
          console.log(position);

          localStorage.setItem("location", JSON.stringify(position));
        },
        (err) => {
          // setError("Error fetching geolocation: " + err.message);
        }
      );
    } else {
      // setError("Geolocation is not supported by this browser.");
    }

    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIpAddress(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));

      
    fetch(`https://us1.api-bdc.net/data/reverse-geocode-client`)
      .then((response) => response.json())
      .then((json) => setLocationData(json));


    const details = getDeviceAndOS();
    setDeviceDetails(details);
  }, []);

  const getDeviceAndOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    // Device Type
    const deviceType = /mobile/i.test(userAgent)
      ? "Mobile"
      : /tablet/i.test(userAgent)
      ? "Tablet"
      : "Desktop";

    // OS Detection
    let os = "Unknown OS";
    if (userAgent.indexOf("win") !== -1) os = "Windows";
    if (userAgent.indexOf("mac") !== -1) os = "MacOS";
    if (userAgent.indexOf("linux") !== -1) os = "Linux";
    if (userAgent.indexOf("android") !== -1) os = "Android";
    if (userAgent.indexOf("iphone") !== -1) os = "iOS";

    return { deviceType, os };
  };

  const Screenwidth = () => {
    if ($(window).width() < 1024) {
      setWidths("mobile");
    } else {
      setWidths("desktop");
    }
  };

  const check = () => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token) {
      if (role == "subadmin") {
        navigate("/hrdashboard");
      } else {
        navigate("/dashboard");
      }
    }
  };
  const Submit = async (e) => {
    e?.preventDefault();
    setLoader(true);
    const email = form.email;
    if (email.includes("@jcsoftwaresolution.com")) {
      const payload = {
        email: form?.email,
        password: form?.password,
        device: widths,
      };
      setLoading(true);
      ApiClient.post("user/signin", payload).then(
        (res) => {
          if (res.success) {
            localStorage.setItem("token", res.data.access_token);
            localStorage.setItem("USERID", res.data.id);
            localStorage.setItem("Name", res.data.fullName);
            localStorage.setItem("Email", res.data.email);
            localStorage.setItem("role", res.data.role);
            localStorage.setItem("userimage", res.data.image);
            localStorage.setItem("tl", res.data.isTL);
            localStorage.setItem("darkMode", res.data.darkMode);

            sessionStorage.setItem("Window", "Open");
            UserPunchIn(res.data.access_token);
            dispatch({
              type: "SET_TOKEN",
              payload: { token: res.data.access_token },
            });
          }
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      );
    } else {
      notification.error({
        message: "Please enter a valid Email.",
      });
    }
  };
  // const UserPunchIn = (data) => {
  //   const newdata = JSON.stringify({ device: widths });
  //   fetch(`${API_URL}attendance/checkin`, {
  //     method: "POST",
  //     headers: {
  //       "Content-type": "application/json",
  //       Authorization: `Bearer ${data}`,
  //     },
  //     body: newdata,
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       localStorage.setItem("device", widths);
  //       localStorage.setItem("LastCheckInTime", res.lastCheckInTime);
  //       history("/attendance");

  //       if (res.alreadyCheckedIn == true) {
  //         notification.success({
  //           message: "You are already Punchedin ",
  //         });
  //         localStorage.setItem("attId", res.checkInId);
  //         localStorage.setItem("PunchIn", true);
  //         localStorage.setItem("checkintime", res.data.checkIntime);

  //       } else {
  //         notification.success({
  //           message: "You Are Punched In",
  //         });
  //         notification.success({
  //           message: "Login Successfully.",
  //         });
  //         localStorage.setItem("PunchIn", true);
  //         localStorage.setItem("attId", res.data.id);
  //       }

  //       // } else {
  //     })
  //     .catch((err) => console.log("You are back"));
  // };
  // attendance/checkin
  const UserPunchIn = (data) => {
    const newdata = JSON.stringify({ device: widths });
    let payload = {
      device: widths,
      ip:ipAddress?ipAddress:'',
      latitude:locationData.latitude?locationData.latitude:'',
      longitude:locationData.longitude?locationData.longitude:'',
      countryCode:locationData.countryCode?locationData.countryCode:'',
      city:locationData.city?locationData.city:'',
      os:deviceDetails.os?deviceDetails.os:'',
      anotherdeviceType:deviceDetails.deviceType?deviceDetails.deviceType:''
    };
    ApiClient.allApi("attendance/checkin", payload, "post")
      .then((res) => {
        localStorage.setItem("device", widths);
        localStorage.setItem("LastCheckInTime", res.lastCheckInTime);
        history("/attendance");
console.log(res);

        if (res.alreadyCheckedIn == true) {          
          notification.success({
            message: "You are already Punchedin",
          });
          localStorage.setItem("attId", res.checkInId);
          localStorage.setItem("PunchIn", true);
          localStorage.setItem("checkintime", res.data.checkIntime);
        } 
        else {          
          notification.success({
            message: "You Are Punched In",
          });
          notification.success({
            message: "Login Successfully.",
          });
          localStorage.setItem("PunchIn", true);
          localStorage.setItem("attId", res.data.id);
        }

        // } else {
      })
      .catch((err) => console.log("You are back"));
  };
  return (
    <>
      <div className="wrapperauth">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6 mx-auto ">
              <div className="mb-5">
                <img src="/img/logo1.png" className="logolog" alt="logo" />
              </div>

              <div className="forms_data">
                <form onSubmit={Submit} className="w-100">
                  <div className="forms_logins mb-4">
                    <h1 className="text-xl mb-0">Sign in</h1>
                    <p>Free access to our dashboard.</p>
                  </div>

                  <div className="main_inners">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        value={form?.email}
                        onChange={(e) => {
                          setForm({ ...form, email: e?.target?.value });
                        }}
                        type="text"
                        placeholder="Enter Email"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <label>Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter password"
                          className="form-control"
                          value={form?.password}
                          onChange={(e) => {
                            setForm({ ...form, password: e?.target?.value });
                          }}
                        />
                        <div
                          className="password_eye"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FiEye /> : <FaRegEyeSlash />}
                        </div>
                      </div>
                    </div>

                    <div className=" text-end">
                      <Link to={"/forgot"} className="forgot text-black">
                        Forgot Password?
                      </Link>
                    </div>

                    <div className=" submit_btncls mt-3 ">
                      <button
                        className="btn btn-primary w-100 shadow-btn h-45"
                        type="submit"
                      >
                        {loading ? (
                          <div className="loader"></div>
                        ) : (
                          <>
                            Submit
                            <div
                              className="loader"
                              style={{ display: "none" }}
                            ></div>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
